// extracted by mini-css-extract-plugin
export default {"page":"Contact_page__jPtMo","content":"Contact_content__0q1sc","container":"Contact_container__peOOc","grid":"Contact_grid__+WSkf"};